import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IInspectionV2 } from "../../../utilities/Interfaces/InspectionInterfaces";

/**
 * Authentication state declaration
 */
export interface InspectionState {
  filterValues: any,
  sortValue: { sortDir: sortDir, sortBy: sortType },
  pageNumber: number,
  pageSize: number,
  totalSelectedInspections: IInspectionV2[],
  totalcount: number

}

/**
 * Initial inspection state definition
 */

enum sortDir {
  asc = "asc",
  desc = "desc"
}

enum sortType {
  id = "Id",
  assetId = "StructureCode",
  inspectionDate = "InspectionDate",
  replacementCost = "ReplacementCost",
  overallCondition = "ConditionRatingWeightedAverage",
}

const initialState: InspectionState = {
  filterValues: null,
  sortValue: { sortDir: sortDir.desc, sortBy: sortType.inspectionDate },
  pageNumber: 1,
  pageSize: 8,
  totalSelectedInspections: [],
  totalcount: 0

};

/**
 * Authentication slice combining actions and reducer
 */
export const inspectionSlice = createSlice({
  name: "inspection",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetInspectionsListState: (state) => {
      state.filterValues = null;
      state.sortValue = { sortDir: sortDir.desc, sortBy: sortType.inspectionDate };
      state.pageNumber = 1;
      state.pageSize = 8;
      state.totalSelectedInspections = [];
      state.totalcount = 0;
    },
    setInspectionsListState: (state, action: PayloadAction<InspectionState>) => {
      state.filterValues = action.payload.filterValues;
      state.sortValue = action.payload.sortValue;
      state.pageNumber = action.payload.pageNumber;
      state.pageSize = action.payload.pageSize;
      state.totalSelectedInspections = action.payload.totalSelectedInspections;
      state.totalcount = action.payload.totalcount;
    },

  },
});

export const { resetInspectionsListState, setInspectionsListState } =
  inspectionSlice.actions;


export default inspectionSlice.reducer;